import React from "react";
import WillBeBackPage from '../WillBeBackPage';
import { Layout } from "../../components/Layout";

function BuyIpadPro(){
    return(
        <Layout bgThemeVariant="light" iconColor="gray">
            <WillBeBackPage
                pageContent='iPad Pro STORE'
            />
        </Layout>
    )
}

export default BuyIpadPro;